import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProgramsComponent } from '../../components/programs/teacher/programs';
import { ProgramsMasterComponent } from '../../components/programs/master/programs-master';
import { TrainingsComponent } from '../../components/trainings/trainings';
import { WorkoutsComponent } from '../../components/workouts/workouts';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';

import { LibraryProvider } from '../../providers/library/library';
import { AuthService } from '../../providers/auth/auth.service';
import { HelpersProvider } from 'src/providers/helpers/helpers';
import { I18nProvider } from '../../providers/i18n/i18n';
import { TrainingProvider } from '../../providers/training/training';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-programas',
  templateUrl: './programas.component.html',
  // styleUrls: ['./dashboard.component.css']
})
export class ProgramasComponent implements OnInit, OnDestroy {
  @ViewChild(ProgramsComponent) private programsView?: ProgramsComponent;
  @ViewChild(ProgramsMasterComponent) private masterProgramsView?: ProgramsMasterComponent;
  @ViewChild(TrainingsComponent) private trainingsView?: TrainingsComponent;
  @ViewChild(WorkoutsComponent) private workoutsView?: WorkoutsComponent;
  STRINGS: any;
  PAGE: any;
  
  loading: boolean = false;
  pid = 0;
  tid = 0;
  fast_program_id: number = 0;
  fastBuild: boolean = false;
  training: any = null;
  cloned_library: any = null;
  moveLeft: boolean = false;
  isClone: boolean = false;
  methodsList: any = [];
  musclesList: any = [];
  equipsList: any = [];
  typesList: any = [];
  user: any = {};
  ismobile: boolean = false;
  istablet: boolean = false;
  resetP: boolean = false;
  resetT: boolean = false;
  resetW: boolean = false;
  showTopper: boolean = true;
  segment: string = 'app-block-programs';
  modernViewportNarrow = false;
  classicViewportNarrow = false;
  private modernViewportSubscription: Subscription;

  constructor(
    public toastr: ToastrService,
    public libraryProvider: LibraryProvider,
    public trainingProvider: TrainingProvider,
    public auth: AuthService,
    public router: Router,
    public route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private device: DeviceDetectorService,
    public helpers: HelpersProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('ProgramasPage');
  }

  ngOnInit() {
    // console.log('page programas - init');
    this.ismobile = this.device.isMobile();
    this.istablet = this.device.isTablet();
    this.istablet = (this.istablet) ? this.helpers.isPortrait() : this.istablet;
    if(!this.auth.isLoggednIn()) {
      this.router.navigate(['/login'], { skipLocationChange: true });
    }
    this.user = this.auth.retrieveLocalUser();
    this.modernViewportSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)', '(max-width: 835px)'])
      .subscribe(result => {
        this.modernViewportNarrow = result.breakpoints['(max-width: 1024px)'];
        this.classicViewportNarrow = result.breakpoints['(max-width: 835px)'];
      });

    this.route.queryParams.subscribe(
      (params: any) => {
        // Defaults to 0 if no query param provided.
        if (params['fastBuild']) {
          this.fastBuild = true;
        }
      }
    );


    this.getMethods();
    this.getMuscles();
    this.getEquips();
    this.getTypes();
  }

  ngOnDestroy() {
    if (this.modernViewportSubscription) this.modernViewportSubscription.unsubscribe();
  }

  fastBuildTraining(id: any) {
    this.loading = true;
    if (this.isModernResponsiveLayout() && !id) {
      this.modernEditing = null;
      this.modernSaving = false;
      this.showSegment('app-block-programs');
    }
    this.pid = id;
    if (id === 0) this.moveLeft = false;
    this.fast_program_id = id;
  }

  finishFastBuild(id: any) {
    // show library
    this.fast_program_id = 0;
    this.tid = id;
    const programId = this.pid;
    setTimeout(() => {
      if (this.pid !== programId || this.tid !== id) return;
      if (this.isMobileNavigation()) this.showSegment('app-block-workouts');
      this.loading = false;
      this.toastr.success((this.PAGE.finalizando_treino_rapido || 'Criação Rápida concluída. Aguarde o carregamento da biblioteca para começar.'), '', this.helpers.toastrCfgs);
      this.toggleLibrary(true);
    }, 2000);
  }

  getProgramId(id: any) {
    if (this.isModernResponsiveLayout() && this.modernSaving && this.modernEditing === 'program' && !id && this.pid > 0) {
      this.modernEditing = null;
      this.modernSaving = false;
      this.showSegment('app-block-trainings');
      return;
    }
    if (this.isModernResponsiveLayout() && id > 0 && !this.modernEditing) {
      if (this.trainingsView) this.trainingsView.selected_training = 0;
      this.tid = 0;
      this.training = null;
    }
    this.pid = id;
    if (id === 0) {
      this.fastBuild = false;
      this.fast_program_id = 0;
      this.tid = 0;
      this.training = null;
      this.moveLeft = false;
      this.isClone = false;
      this.cloned_library = null;
      this.modernEditing = null;
      this.trainingsView?.resetMobileToList();
      this.workoutsView?.resetMobileToList();
      this.showSegment('app-block-programs');
    }
    if (id > 0 && this.isMobileNavigation()) this.showSegment('app-block-trainings');
  }

  getTrainingId(id: any) {
    if (this.isModernResponsiveLayout() && this.modernSaving && this.modernEditing === 'training' && !id && this.tid > 0) {
      this.modernEditing = null;
      this.modernSaving = false;
      this.showSegment('app-block-workouts');
      return;
    }
    if (this.isModernResponsiveLayout() && !id) {
      this.modernEditing = null;
      this.modernSaving = false;
      if (this.pid > 0) this.showSegment('app-block-trainings');
    }
    this.tid = id;
    // console.log('page programs - tid:' + id);
    if (id === 0) this.moveLeft = false;
    if (id > 0 && this.isMobileNavigation()) this.showSegment('app-block-workouts');
  }

  getTraining(training: any) {
    if (training === 0 && this.isModernResponsiveLayout() && this.tid > 0) return;
    if (training === 0) {
      this.training = {};
    } else {
      this.training = training;
    }
    if (training.id) this.moveLeft = false;
  }

  // ativa a abertura da biblioteca do panel de exercicios
  toggleLibrary(_val: any) {
    // this.moveLeft = !this.moveLeft;
    this.moveLeft = _val;
    this.isClone = true;
    this.cloned_library = null;
  }

  // recebe o fechamento da biblioteca do panel de biblioteca
  getClonedLibrary(cloned_library: any = null) {
    if (cloned_library === null) {
      this.moveLeft = false;
    } else {
      this.cloned_library = cloned_library;
    }
  }

  getMethods() {
    this.libraryProvider.libraryMethods().then(
      (res: any) => {
        this.methodsList = res.methods;
      },
      (err: any) => {
        console.log(err);
      });
  }

  getMuscles() {
    this.libraryProvider.libraryMuscles().then(
      (res: any) => {
        this.musclesList = res.muscles;
      },
      (err: any) => {
        console.log(err);
      });
  }

  getEquips() {
    this.libraryProvider.libraryEquips().then(
      (res: any) => {
        this.equipsList = res.equips;
      },
      (err: any) => {
        console.log(err);
      });
  }

  getTypes() {
    this.libraryProvider.libraryTypes().then(
      (res: any) => {
        this.typesList = res.types;
      },
      (err: any) => {
        console.log(err);
      });
  }

  goBack() {
    this.showTopper = false;
    this.fast_program_id = 0;
    if (this.segment === 'app-block-trainings') this.resetP = true;
    if (this.segment === 'app-block-workouts') this.resetT = true;
    this.resetW = true;
    setTimeout(() => {
      if (this.segment === 'app-block-trainings') this.showSegment('app-block-programs');
      if (this.segment === 'app-block-workouts') this.showSegment('app-block-trainings');
    },250);
    setTimeout(() => {
      this.resetP = false;
      this.resetT = false;
      this.resetW = false;
    },150);
    setTimeout(() => {
      this.showTopper = true;
    },750);
  }

  goBackMobile() {
    if (!this.isMobileNavigation()) return;

    // Limpeza local e síncrona: não dispara os resets legados nem navegação dos filhos.
    this.programsView?.resetMobileToList();
    this.masterProgramsView?.resetMobileToList();
    this.trainingsView?.resetMobileToList();
    this.workoutsView?.resetMobileToList();
    this.moveLeft = false;
    this.isClone = false;
    this.cloned_library = null;
    this.fastBuild = false;
    this.fast_program_id = 0;
    this.pid = 0;
    this.tid = 0;
    this.training = null;
    this.loading = false;
    this.showSegment('app-block-programs');
    this.showTopper = true;
  }

  canGoBackMobile() {
    return this.segment !== 'app-block-programs' || this.moveLeft ||
      !!(this.programsView && this.programsView.selected_program !== 0) ||
      !!(this.masterProgramsView && this.masterProgramsView.selected_program !== 0);
  }

  isMobileNavigation() {
    // O Classic já usa o layout de uma coluna até 835 px no SCSS legado.
    return this.ismobile || this.istablet || this.isModernResponsiveLayout() ||
      (!this.isModernLayoutActive() && this.classicViewportNarrow);
  }

  showSegment(segment: string) {
    if (this.pid === 0 && segment === 'app-block-trainings') return false;
    if (this.tid === 0 && segment === 'app-block-workouts') return false;
    this.segment = segment;

    const programs = document.getElementById('app-block-programs');
    if (programs) programs.style.display = 'none';

    const trainings = document.getElementById('app-block-trainings');
    if (trainings) trainings.style.display = 'none';

    const workouts = document.getElementById('app-block-workouts');
    if (workouts) workouts.style.display = 'none';

    // document.getElementById('app-block-library').style.display = 'none';

    const segmento = document.getElementById(segment);
    if (segmento) segmento.style.display = 'block';

    // if (segment === 'app-block-workouts') document.getElementById('app-block-library').style.display = 'block';
  }

  modernEditing: 'program' | 'training' | null = null;
  private modernEditSnapshot = '';
  private modernSaving = false;
  private modernProgramExpiration: any = null;

  get modernProgramView() { return this.programsView || this.masterProgramsView; }

  get modernProgramName(): string {
    const view = this.modernProgramView;
    const item = view && view.programs && view.programs.find(program => program.id == this.pid);
    return (view && view.program && view.program.id == this.pid && view.program.name) ||
      (item && item.name) || this.PAGE.programas || 'Programas';
  }

  get modernTrainingName(): string {
    const item = this.trainingsView && this.trainingsView.trainings &&
      this.trainingsView.trainings.find(training => training.id == this.tid);
    return (item && item.name) || (this.training && this.training.name) || this.PAGE.treinos || 'Treinos';
  }

  get modernEditor(): 'program' | 'training' | null {
    if (this.segment === 'app-block-programs' && this.modernProgramView && this.modernProgramView.selected_program !== 0) return 'program';
    if (this.segment === 'app-block-trainings' && this.trainingsView && this.trainingsView.selected_training !== 0) return 'training';
    return null;
  }

  get modernNavigationBusy(): boolean {
    return this.loading || !!(this.modernProgramView && this.modernProgramView.loading) ||
      !!(this.trainingsView && this.trainingsView.loading);
  }

  get modernTitle(): string {
    if (this.modernEditor === 'program') return this.modernProgramView.selected_program === -1 ? 'Novo programa' : (this.PAGE.editar_programa || 'Editar programa');
    if (this.modernEditor === 'training') return this.trainingsView.selected_training === -1 ? 'Novo treino' : (this.PAGE.editar_treino || 'Editar treino');
    if (this.moveLeft) return 'Adicionar exercício';
    if (this.segment === 'app-block-workouts') return 'Exercícios de ' + this.modernTrainingName;
    if (this.segment === 'app-block-trainings') return 'Treinos de ' + this.modernProgramName;
    return this.PAGE.programas || 'Programas';
  }

  get modernWorkoutEditing(): boolean {
    return this.segment === 'app-block-workouts' && !!this.workoutsView &&
      this.workoutsView.selected_workout !== 0;
  }

  get modernBackLabel(): string {
    if (this.modernEditor) return this.STRINGS.bt_cancelar || 'Cancelar';
    if (this.moveLeft) return 'Fechar biblioteca';
    if (this.modernWorkoutEditing) return this.STRINGS.exercicios || 'Exercícios';
    return this.segment === 'app-block-workouts' ? (this.PAGE.treinos || 'Treinos') : (this.PAGE.programas || 'Programas');
  }

  modernEdit(): void {
    if (this.modernNavigationBusy) return;
    if (this.segment === 'app-block-workouts') {
      this.modernEditing = 'training';
      this.modernEditSnapshot = '';
      this.trainingsView.getTraining(this.tid).then(() => {
        this.modernEditSnapshot = JSON.stringify(this.trainingsView.training);
      });
      this.showSegment('app-block-trainings');
    } else {
      this.modernProgramView.selected_program = this.pid;
      this.modernEditing = 'program';
      this.modernProgramExpiration = this.programsView ? this.programsView.programExpiration.value : null;
      this.modernEditSnapshot = JSON.stringify(this.modernProgramView.program);
      this.showSegment('app-block-programs');
    }
  }

  modernSaveCompleted(): void {
    this.modernSaving = this.isModernResponsiveLayout() && !!this.modernEditing;
  }

  modernSave(): void {
    if (this.modernNavigationBusy) return;
    if (this.modernEditor === 'program') this.modernProgramView.saveProgram();
    if (this.modernEditor === 'training') this.trainingsView.saveTraining();
  }

  modernBack(): void {
    if (this.modernNavigationBusy) return;
    const editor = this.modernEditor;
    if (editor) {
      const model = editor === 'program' ? this.modernProgramView.program : this.trainingsView.training;
      if ((!this.modernEditSnapshot || JSON.stringify(model) !== this.modernEditSnapshot ||
          (editor === 'program' && this.programsView && this.programsView.programExpiration.value !== this.modernProgramExpiration)) &&
          !window.confirm('Descartar as alterações e sair da edição?')) return;
      if (this.modernEditSnapshot) {
        if (editor === 'program') {
          this.modernProgramView.program = JSON.parse(this.modernEditSnapshot);
          if (this.programsView) this.programsView.programExpiration.setValue(this.modernProgramExpiration);
        }
        else this.trainingsView.training = JSON.parse(this.modernEditSnapshot);
      }
      this.modernSaving = false;
      const origin = this.modernEditing;
      this.modernEditing = null;
      this.modernEditSnapshot = '';
      if (origin === 'program') { this.showSegment('app-block-trainings'); return; }
      if (origin === 'training') { this.showSegment('app-block-workouts'); return; }
      if (editor === 'program') this.modernProgramView.resetMobileToList();
      else this.trainingsView.resetMobileToList();
      return;
    }
    if (this.moveLeft) { this.toggleLibrary(false); return; }
    if (this.modernWorkoutEditing) {
      this.workoutsView.goBack(false);
      return;
    }
    if (this.segment === 'app-block-workouts') {
      this.trainingsView.selected_training = 0;
      this.showSegment('app-block-trainings');
      return;
    }
    this.modernProgramView.selected_program = 0;
    this.showSegment('app-block-programs');
  }

  modernNavigatePrograms(): void {
    if (this.modernEditor) {
      this.modernBack();
      if (this.modernEditor) return;
    }
    if (this.moveLeft) this.toggleLibrary(false);
    if (this.modernProgramView) this.modernProgramView.selected_program = 0;
    this.showSegment('app-block-programs');
  }

  modernNavigateTrainings(): void {
    if (this.modernEditor) { this.modernBack(); return; }
    this.toggleLibrary(false);
    this.trainingsView.selected_training = 0;
    this.showSegment('app-block-trainings');
  }

  modernNewProgram(): void {
    this.modernEditSnapshot = '';
    this.modernEditing = null;
    this.modernProgramView.new();
  }

  private isModernLayoutActive() {
    return document.body.classList.contains('layout-modern-dark') ||
      document.body.classList.contains('layout-modern-light');
  }

  isModernResponsiveLayout() {
    return this.modernViewportNarrow && this.isModernLayoutActive();
  }

}
